import React, { useContext, useRef } from 'react';
import styled from 'styled-components';

import { AnswersListType } from 'models/answer_panel';
import AnswerPanelContext from 'components/customer/answer_panel/answer_panel_context';
import AnswerSearchInput from 'components/customer/answer_panel/search/answer_search_input';
import AnswerSearchResults from 'components/customer/answer_panel/search/answer_search_results';
import AnswerSuggestions from 'components/customer/answer_panel/search/answer_suggestions';
import EmptyAnswerSearch from 'components/customer/answer_panel/search/empty_answer_search';
import LanguageSort from 'components/customer/answer_panel/search/answer_search_language_sort';
import PlaceholderAnswerSearch from 'components/customer/answer_panel/search/placeholder_answer_search';
import Sort from 'components/customer/answer_panel/search/answer_search_sort';
import useKeyboardNavigation from 'components/customer/answer_panel/search/use_keyboard_navigation';

export default function AnswerSearch() {
  const { answersList, focusedAnswer, searchText } = useContext(AnswerPanelContext);
  const hasAnswers = answersList.answers.length > 0;

  const searchRef = useRef(null);
  const onKeyDown = useKeyboardNavigation(searchRef, answersList.answers, focusedAnswer && focusedAnswer.id);

  let content;
  if (answersList.type === AnswersListType.SEARCH && searchText && hasAnswers) {
    content = <AnswerSearchResults />;
  } else if (answersList.type === AnswersListType.SEARCH && searchText) {
    content = <EmptyAnswerSearch />;
  } else if (answersList.type === AnswersListType.SUGGESTIONS && hasAnswers) {
    content = <AnswerSuggestions />;
  } else {
    content = <PlaceholderAnswerSearch />;
  }

  function renderFilters() {
    return (
      <StyledFilterWrapper>
        <LanguageSort />
        <Sort />
      </StyledFilterWrapper>
    );
  }

  return (
    <AnswerSearchContainer onKeyDown={onKeyDown} ref={searchRef} tabIndex="0">
      <AnswerSearchInput />
      {renderFilters()}
      {content}
    </AnswerSearchContainer>
  );
}

const StyledFilterWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
`;

const AnswerSearchContainer = styled.div`
  border: 0;
  border-bottom: 1px solid ${p => p.theme.colors.gray400};
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  height: 35%;
  outline: none;
`;



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/customer/answer_panel/search/answer_search.jsx